import { Box, Button, fade, withStyles } from '@material-ui/core';

export const Backdrop = withStyles(({ palette }) => ({
  root: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: fade(palette.common.black, 0.4),
    zIndex: 9,
    cursor: 'pointer',
  },
}))(Box);

export const WrapperBox = withStyles(({ palette, spacing, breakpoints }) => ({
  root: {
    position: 'fixed',
    top: 0,
    left: 0,
    transform: `translateX(-250px)`,
    width: 250,
    height: '100vh',
    overflowY: 'auto',
    borderRight: `1px solid ${palette.grey[200]}`,
    backgroundColor: palette.background.default,
    zIndex: 10,
    overflow: 'hidden',
    transition: `transform .3s ease-in-out`,
    display: 'flex',
    minHeight: 0,
    minWidth: 0,
    [breakpoints.up('md')]: {
      transform: `translateX(0)`,
    },
  },
}))(Box);

export const ContentBox = withStyles(({ spacing }) => ({
  root: {
    padding: spacing(6, 3, 3, 3),
  },
}))(Box);

export const LogoContainerBox = withStyles(({ spacing }) => ({
  root: {
    marginBottom: spacing(6),
    paddingLeft: spacing(2.5),
  },
}))(Box);

export const StyledIconButton = withStyles(({ spacing }) => ({
  root: {
    padding: spacing(0.5),
    borderRadius: spacing(1),
    '&:hover': {
      background: 'transparent',
    },
  },
}))(Button);
